export default __webpack_public_path__ + "static/media/people10.fdd03c68.jpeg";